const EDITABLE_SELECTOR = [
  'input',
  'textarea',
  'select',
  '[contenteditable=""]',
  '[contenteditable="true"]',
  '[role="textbox"]',
  '[role="combobox"]',
  '[role="listbox"]',
  '[role="menu"]',
  '[role="slider"]',
  '[role="dialog"]',
].join(', ');

// Arrow-key month paging must not steal keys from text fields, menus or open dialogs.
export function shouldIgnoreMonthArrowKey(event, doc = typeof document !== 'undefined' ? document : null) {
  if (!event || event.defaultPrevented) return true;
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return true;
  const target = event.target;
  if (target && target.isContentEditable) return true;
  if (target && typeof target.closest === 'function' && target.closest(EDITABLE_SELECTOR)) return true;
  if (doc && doc.querySelector('[aria-modal="true"], [role="dialog"]')) return true;
  return false;
}

export function getMonthArrowOffset(key) {
  if (key === 'ArrowLeft') return -1;
  if (key === 'ArrowRight') return 1;
  return 0;
}
